import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import ReverseRelevanceList from "./reverse-relevance-list.vue";
import ReverseRelevanceLink from "./reverse-relevance-link.vue";
import { ReverseRelevanceControl } from "@cloudpivot/form/src/common/controls/reverse-relevance-control";
import common from "@cloudpivot/common/pc";
let ReverseRelevance = class ReverseRelevance extends ReverseRelevanceControl {
    get tips() {
        return this.control.options.tips;
    }
};
ReverseRelevance = tslib_1.__decorate([
    Component({
        name: "reverse-relevance",
        components: {
            ReverseRelevanceList,
            ReverseRelevanceLink,
            H3Panel: common.components.Panel,
        },
    })
], ReverseRelevance);
export default ReverseRelevance;
